export default __webpack_public_path__ + "assets/1095543ad37813d8acdd3cc0a885aee0.jpg";